import ReduxHelper from 'lib/ReduxHelper';

export const MERCHANT_FEES_ACTION_TYPES = {
  MERCHANT_FEES_FETCH_DATA: 'MERCHANT_FEES_FETCH_DATA',
  MERCHANT_FEES_FETCH_DATA_SUCCESS: 'MERCHANT_FEES_FETCH_DATA_SUCCESS',
  MERCHANT_FEES_FETCH_DATA_FAIL: 'MERCHANT_FEES_FETCH_DATA_FAIL',
  MERCHANT_FEES_FETCH_CLEAR_DATA: 'MERCHANT_FEES_FETCH_CLEAR_DATA',

  MERCHANT_FEES_UPDATE_DATA: 'MERCHANT_FEES_UPDATE_DATA',
  MERCHANT_FEES_UPDATE_DATA_SUCCESS: 'MERCHANT_FEES_UPDATE_DATA_SUCCESS',
  MERCHANT_FEES_UPDATE_DATA_FAIL: 'MERCHANT_FEES_UPDATE_DATA_FAIL',
  MERCHANT_FEES_UPDATE_CLEAR_DATA: 'MERCHANT_FEES_UPDATE_CLEAR_DATA',

  MERCHANT_FEES_CLEAR_DATA: 'MERCHANT_FEES_CLEAR_DATA',
};

export const fetchMerchantFeesData = merchantID =>
  ReduxHelper.createAction(
    MERCHANT_FEES_ACTION_TYPES.MERCHANT_FEES_FETCH_DATA,
    merchantID
  );

export const clearMerchantFeesData = () =>
  ReduxHelper.createAction(MERCHANT_FEES_ACTION_TYPES.MERCHANT_FEES_CLEAR_DATA);

export const updateMerchantFeesData = (feeIDs, isPaid) =>
  ReduxHelper.createAction(
    MERCHANT_FEES_ACTION_TYPES.MERCHANT_FEES_UPDATE_DATA,
    {
      feeIDs,
      isPaid,
    }
  );
